export default theme => ({
  countryLabel: {
    marginLeft: 7
  }
})
